import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../rootSelectors';
import NWView from '../../NWView';
import * as multiChoiceUtils from '../../../common/questions/multiChoiceQuestionUtils';
import { goToCountdown } from '../../../common/navigation/navigationActions';
import {
    narrateStimulus, selectPossibleResponse, resetSelectedIndex,
    resetQuestionsAndTimeTrackingState,
} from '../../../common/questions/questionsActions';
import {
    blockScreen, unblockScreen, greyOutScreen, activateNextButton, unmountScreen,
}
    from '../../../common/screen/screenActions';
import { narrateStart, narrateReset, stopAudio } from '../../../common/audio/audioActions';
import { fetchNWContent } from '../../nwActions';
import { narratePracticeScreen, narratePracticeReadyScreen } from './NWPracticeActions';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { PRACTICE } from '../../../constants/assessmentItemType';
import { NW } from '../../../constants/measure';

const mapStateToProps = (state) => {
    const props = multiChoiceUtils.mapStateToProps(state);
    return {
        ...props,
        pageLayout: `${NW.ASSESSMENT}`,
        isDataFetched: selectors.getIsNWDataFetched(state),
        possibleResponses: selectors.getNWPossibleResponses(state, PRACTICE),
        stimulusAudio: selectors.getNWStimulusAudio(state, PRACTICE),
    };
};

const mapDispatchToProps = (dispatch) => {
    const props = multiChoiceUtils.mapDispatchToProps(dispatch);
    return {
        ...props,
        fetchContent: () => {
            dispatch(fetchNWContent());
        },
        narrateStimulus: (stimulusAudio) => {
            dispatch(narrateStimulus(stimulusAudio));
        },
        narrateScreen: async (stimulusAudio) => {
            dispatch(blockScreen());
            dispatch(narrateStart());
            await dispatch(narratePracticeScreen(stimulusAudio));
            dispatch(resetSelectedIndex());
            dispatch(narrateReset());
            dispatch(unblockScreen());
        },
        selectResponse: async (index) => {
            dispatch(blockScreen());
            dispatch(greyOutScreen());
            dispatch(selectPossibleResponse(index));
            await dispatch(narratePracticeReadyScreen());
            dispatch(unblockScreen());
            dispatch(activateNextButton());
        },
        onNext: () => {
            dispatch(goToCountdown(NW.ASSESSMENT));
        },
        cleanup: () => {
            dispatch(stopAudio());
            dispatch(narrateReset());
            dispatch(resetQuestionsAndTimeTrackingState());
            dispatch(unmountScreen());
        },
    };
};

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
});

const NWModelContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(NWView);

export default NWModelContainer;
